import { useDispatch, useSelector } from 'react-redux'
import { Environment } from '@carsys/enums/environment'
import { IRootReducerState } from 'state/rootReducer'
import NewEnvironmentSuite from '@cbgms/components/environment/environmentUtils'
import { setSimulatedEnvironment } from 'app/menu/state/actions'

const useEnvironment = () => {
  return useSelector((state: IRootReducerState) => state.environment.Environment)
}

const useSimulatedEnvironment = () => {
  return useSelector((state: IRootReducerState) => state.menu?.simulatedEnvironment)
}

const useSetSimulatedEnvironment = () => {
  const dispatch = useDispatch()
  return (value: Environment) => dispatch(setSimulatedEnvironment(value))
}

const suite = NewEnvironmentSuite(Environment, {
  useEnvironment,
  useSimulatedEnvironment,
  useSetSimulatedEnvironment
})

export const EnvironmentFeature = suite.EnvironmentFeature
export const useHasEnvironmentFeature = suite.useHasEnvironmentFeature
export const useHasEnvironmentFeatureFunc = suite.useHasEnvironmentFeatureFunc
export const EnvironmentSimulator = suite.EnvironmentSimulator
export default suite.EnvironmentFeature
